<template>
  <TableLayout :permissions="['meihui:userMood:query']">
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="80px" inline>
      <el-form-item label="用户ID"><el-input v-model="searchForm.userId" placeholder="用户ID" @keypress.enter.native="search" /></el-form-item>
      <section><el-button type="primary" @click="search">搜索</el-button><el-button @click="reset">重置</el-button></section>
    </el-form>
    <template v-slot:table-wrap>
      <ul class="toolbar">
        <li><el-button type="primary" @click="$refs.opera.open('新建用户心情')"" icon="el-icon-plus" v-permissions="['meihui:userMood:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['meihui:userMood:delete']">批量删除</el-button></li>
      </ul>
      <el-table v-loading="isWorking.search" :data="tableData.list" stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column prop="id" label="ID" width="80" show-overflow-tooltip />
        <el-table-column prop="userId" label="用户ID" width="100" show-overflow-tooltip />
        <el-table-column prop="moodValue" label="情绪值" width="80" show-overflow-tooltip />
        <el-table-column prop="moodLabel" label="情绪标签" width="100" show-overflow-tooltip />
        <el-table-column prop="moodIcon" label="图标" width="80" show-overflow-tooltip />
        <el-table-column prop="recordDate" label="日期" width="120" show-overflow-tooltip />
        <el-table-column prop="createTime" label="创建时间" width="180" show-overflow-tooltip />
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.opera.open('编辑用户心情', row)"" icon="el-icon-edit" v-permissions="['meihui:userMood:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['meihui:userMood:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination @size-change="handleSizeChange" @current-change="handlePageChange" :pagination="tableData.pagination" />
    </template>
    <operauserMoodWindow ref="opera" @success="handlePageChange" />
  </TableLayout>
</template>
<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import operauserMoodWindow from './operauserMoodWindow'
export default {
  name: 'UserMood', extends: BaseTable, components: { TableLayout, Pagination, operauserMoodWindow },
  data() { return { searchForm: {} } },
  created() {
    this.config({ module: '用户心情', api: '/rentHouse/userMood', 'field.id': 'id', 'field.main': 'id' })
    this.search()
  }
}
</script>